export const LAUNCHSTAGE = {
    QA: 'QA',
    PROD: 'PROD',
    HOMOLOG: 'HOMOLOG'
}